/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DoubleArrowRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DoubleArrowRight({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DoubleArrowRight",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DoubleArrowRight.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 10"
 style={{'--as-1-1IyGAR': alignSelf,'--mt-2-1IyGAR': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1IyGAR': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1IyGAR': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1IyGAR': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1IyGAR': opacity,'--w-10-1IyGAR': typeof width === 'number' ? `${width}px` : width,'--h-11-1IyGAR': typeof height === 'number' ? `${height}px` : height,'--f-12-1IyGAR': fill,'--a-7-1IyGAR': isAnimated ? animation : "none",'--sd-8-1IyGAR': isAnimated ? strokeDashoffset : 0,'--sd-9-1IyGAR': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2DoubleArrowRight.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2176_4009)"
 className="views-block"
>
<path
  data-testid="Tysiav2DoubleArrowRight.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.006.027a.357.357 0 00-.22.33v2.71L1.824.104a.357.357 0 00-.61.252v9.286a.357.357 0 00.61.252l2.962-2.961v2.709a.357.357 0 00.61.252l4.382-4.39a.7.7 0 000-1.01L5.396.104a.357.357 0 00-.39-.078z"
 style={{'--f-12-1IyGAR': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}